// extracted by mini-css-extract-plugin
export default {"container":"Header_container__UMOOJ","pricingContainer":"Header_pricingContainer__94ji9","legend":"Header_legend__M5DkF","icon":"Header_icon__sML6e","vin":"Header_vin__4Q-T0"};